import './index.pcss';
import { renderApp } from './render-app';
import { config } from './config';
import { StoreCard } from './StoreCard/StoreCard';
import { RewardStepCard } from './components/RewardSytem/RewardStepCard/RewardStepCard';
window.customApi = {
    init: (configData) => {
        const updatedConfig = config.setConfig(configData);
        renderApp(updatedConfig);
    },
    methods: {},
    components: {
        storeCard: StoreCard,
        rewardStepCard: RewardStepCard,
    },
};
